import {
    BodyLargeRegular,
    Icon,
    type IconType,
    LabelRegular,
    Shadows,
    SizableText,
    type StackProps,
    View,
    XStack,
    YStack,
} from 'smoothie';

export interface DummyCategoryCardProps extends StackProps {
    icon: IconType;
    label: string;
    amount: string;
    accountCount: number;
}

export const DummyCategoryCard = ({
    icon,
    label,
    amount,
    accountCount,
    ...props
}: DummyCategoryCardProps) => {
    return (
        <YStack
            justifyContent="space-between"
            gap={4}
            backgroundColor="$white"
            borderStyle="solid"
            borderWidth={1}
            borderColor="$gray200"
            width={124}
            height={90}
            padding={8}
            style={{ ...Shadows.SMALL }}
            {...props}
        >
            <XStack alignItems="center" justifyContent="space-between">
                <LabelRegular>{label}</LabelRegular>
                <View padding={5} backgroundColor="$gray100" borderRadius={4}>
                    <Icon icon={icon} size={10} color="$gray1100" />
                </View>
            </XStack>

            <YStack gap={3}>
                <BodyLargeRegular>{amount}</BodyLargeRegular>

                <SizableText fontSize={9} fontWeight="600" color="$gray1000">
                    {accountCount} accounts
                </SizableText>
            </YStack>
        </YStack>
    );
};
